export const FRONTEND_VERSION = "7.6.1";
